"use client";

import { useRef } from "react";
import { usePathname } from "next/navigation";
import { useAppDispatch } from "stores/hooks";
import { resetLocationInput } from "stores/location-input/locationInputSlice";
import { useIsomorphicLayoutEffect } from "utils/hooks/useIsomorphicLayoutEffect";

/**
 * Leaving a page drops text typed (but not searched) in the location field and any
 * error it showed, so neither follows the user to the next page or back.
 * Runs before paint, so the next page never flashes the old error.
 */
const LocationInputRouteReset = () => {
  const pathname = usePathname();
  const dispatch = useAppDispatch();
  const previousPathname = useRef(pathname);
  useIsomorphicLayoutEffect(() => {
    if (previousPathname.current === pathname) return;
    previousPathname.current = pathname;
    dispatch(resetLocationInput({
      scope: "search"
    }));
    dispatch(resetLocationInput({
      scope: "local"
    }));
  }, [dispatch, pathname]);
  return null;
};
export default LocationInputRouteReset;